import { render, staticRenderFns } from "./CreatePredictService.vue?vue&type=template&id=1ddd1fc1&"
import script from "./CreatePredictService.vue?vue&type=script&lang=js&"
export * from "./CreatePredictService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports